import getters from "./getters";
import state from "./state";

export default {
  state: state,
  getters: getters,
};
